// extracted by mini-css-extract-plugin
export var chevron = "_kb-2";
export var chevronRotated = "_kb-3";
export var header = "_kb-1";
export var section = "_kb-0";